import Avatar from "components/v2/Avatar/Avatar";

interface QuotationOwnerProps {
  quotation: any;
}

export default function QuotationOwner({ quotation }: QuotationOwnerProps) {
  return (
    <div className="d-flex align-items-center gap-md">
      <Avatar image={quotation?.provider?.logo} name={quotation?.provider?.name} />
      <div>
        <div className="text-md font-medium">{quotation?.provider?.name}</div>
        <div className="text-xs text-tertiary">{quotation?.general?.quote_title}</div>
      </div>
    </div>
  );
}
